import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/virus-head.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-fb5ad4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cloud-feature-offline-library-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"display":"block","margin":"10px auto 30px","width":"500px"},
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "病毒库同步步骤：", -1))
const _hoisted_4 = {
  key: 0,
  class: "step-section had-next"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("第一步")
], -1))
const _hoisted_6 = { class: "ctn" }
const _hoisted_7 = { class: "s cm-ui-mb10" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "cm-ui-mr10" }, "下载获取授权", -1))
const _hoisted_9 = {
  key: 0,
  class: "info cm-ui-ml5"
}
const _hoisted_10 = {
  class: "s",
  style: {"margin-bottom":"55px"}
}
const _hoisted_11 = { class: "step-section had-next" }
const _hoisted_12 = { class: "ctn" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s cm-ui-mb10" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "请通过可以连接外网的电脑，访问网址")
], -1))
const _hoisted_14 = {
  class: "s cm-ui-mb10",
  style: {"display":"flex"}
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  class: "s",
  style: {"margin-bottom":"55px"}
}
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "step-section" }
const _hoisted_20 = { class: "ctn" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "s cm-ui-mb10" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "上传更新包，完成更新")
], -1))
const _hoisted_22 = {
  class: "s",
  style: {"display":"flex"}
}
const _hoisted_23 = { class: "file-select" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-select-file" }, null, -1))
const _hoisted_25 = { class: "s" }
const _hoisted_26 = {
  key: 0,
  class: "upload-result"
}
const _hoisted_27 = {
  key: 0,
  class: "running"
}
const _hoisted_28 = {
  key: 1,
  class: "fail"
}
const _hoisted_29 = {
  key: 2,
  class: "succ"
}
const _hoisted_30 = { class: "cm-ui-ml10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_UploadDialog = _resolveComponent("UploadDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_ctx.type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              (_ctx.viewModel.lastBuildTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createTextVNode("上次生成时间："),
                    _withDirectives(_createElementVNode("span", null, null, 512), [
                      [_directive_date_format, {value: _ctx.viewModel.lastBuildTime * 1000, format: 'YYYY-MM-DD HH:mm'}]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleBuildLicenseFile,
                loading: _ctx.viewModel.buildingLicense
              }, {
                default: _withCtx(() => [
                  _createTextVNode("立即下载")
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_el_button, {
                class: "cm-ui-ml10",
                type: "primary",
                disabled: _ctx.viewModel.buildingLicense,
                onClick: _ctx.handleDownLicenseFile
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载文件")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.type?2:1), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.type ? '第二步':'第一步'), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_ctx.type)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "update-url",
                ref: "updateUrlNode",
                href: `${ _ctx.viewModel.saasBaseUrl }/cloud-library-update?token=${ _ctx.viewModel.token }`,
                target: "_blank"
              }, _toDisplayString(_ctx.viewModel.saasBaseUrl) + "/cloud-library-update?token=" + _toDisplayString(_ctx.viewModel.token), 9, _hoisted_15))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "update-url",
                ref: "updateUrlNode",
                href: _ctx.viewModel.download_url,
                target: "_blank"
              }, _toDisplayString(_ctx.viewModel.download_url), 9, _hoisted_16)),
          _createVNode(_component_el_button, {
            class: "cm-ui-ml10",
            type: "text",
            onClick: _ctx.handleCopyUpdateUrl
          }, {
            default: _withCtx(() => [
              _createTextVNode("复制")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.type? '上传同步授权文件，并获得病毒库离线库更新包':'登录网址,获取最新病毒库'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("label", null, [
        _createElementVNode("span", null, _toDisplayString(_ctx.type?3:2), 1),
        _createTextVNode(_toDisplayString(_ctx.type ? '第三步':'第二步'), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_input, {
              class: "file-path",
              modelValue: _ctx.viewModel.fileName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewModel.fileName) = $event)),
              placeholder: "未选择任何文件",
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_upload, {
              ref: "uploadNode",
              class: "file-upload",
              action: `${_ctx.getBaseUrl()}/upgrade/upload`,
              name: "file",
              limit: 1,
              "show-file-list": false,
              "auto-upload": false,
              "http-request": _ctx.handleHttpUpload,
              onChange: _ctx.handleChange,
              onSelect: _ctx.handleChange,
              onClick: _ctx.handleClick
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["action", "http-request", "onChange", "onSelect", "onClick"])
          ]),
          _createVNode(_component_el_button, {
            class: "upload-btn cm-ui-ml10",
            size: "medium",
            type: "primary",
            disabled: _ctx.viewModel.uploading === _ctx.TASK_STATUS_OPTIONS.RUNNING,
            onClick: _ctx.handleSelectFile
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 选择 ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            class: "upload-btn cm-ui-ml10",
            size: "medium",
            type: "primary",
            disabled: !_ctx.viewModel.uploadFile?.raw || _ctx.viewModel.uploading === _ctx.TASK_STATUS_OPTIONS.RUNNING,
            onClick: _ctx.handleSubmitUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 上传 ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.viewModel.lastUpdateTime)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createTextVNode(" 上次更新结果： "),
                (_ctx.viewModel.uploading === _ctx.TASK_STATUS_OPTIONS.RUNNING)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "更新中"))
                  : ([_ctx.TASK_STATUS_OPTIONS.TIMEOUT,_ctx.TASK_STATUS_OPTIONS.FAIL].includes(_ctx.viewModel.uploading))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                        _createTextVNode(" 更新失败 "),
                        (_ctx.viewModel.uploading === _ctx.TASK_STATUS_OPTIONS.FAIL)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" ： " + _toDisplayString(_ctx.viewModel.errorMsg), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        _createTextVNode("更新成功"),
                        _withDirectives(_createElementVNode("span", _hoisted_30, null, 512), [
                          [_directive_date_format, {value: _ctx.viewModel.lastUpdateTime * 1000, format: 'YYYY-MM-DD HH:mm'}]
                        ])
                      ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      "append-to-body": "",
      title: "更新病毒库",
      modelValue: _ctx.viewModel.uploadDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.viewModel.uploadDialog) = $event)),
      "close-on-click-modal": false,
      width: 470,
      "before-close": _ctx.resetUpload,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        (_ctx.viewModel.uploading === 1)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "btn",
              size: "small",
              onClick: _ctx.resetUpload
            }, {
              default: _withCtx(() => [
                _createTextVNode("取 消")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "btn",
              size: "small",
              type: "primary",
              onClick: _ctx.uploadDone
            }, {
              default: _withCtx(() => [
                _createTextVNode("确 定")
              ]),
              _: 1
            }, 8, ["onClick"]))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_UploadDialog, {
          "error-msg": _ctx.viewModel.errorMsg,
          "file-name": _ctx.viewModel.fileName,
          percent: _ctx.viewModel.percentage,
          uploading: _ctx.viewModel.uploading
        }, null, 8, ["error-msg", "file-name", "percent", "uploading"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}